'use strict';

var WSConnection = require('../transports/websocket');


module.exports = function (client) {

    client.transports.websocket = WSConnection;
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/websocket.js
// module id = 544
// module chunks = 2